class TextVideo {
  constructor(block) {
    this.block = block
    this.videoWrapper = block.querySelector(".text-video__video")
    this.videoLink = block.querySelector(".text-video__video-link")

    this.events()
  }

  events() {
    this.videoLink.addEventListener("click", (e) => this.playVideo(e))
  }

  playVideo(e) {
    e.preventDefault()

    if (this.videoLink.dataset.display == "embed") {
      this.videoEmbedInit()
    } else if (this.videoLink.dataset.display == "modal") {
      this.videoModalInit()
    }
  }

  videoEmbedInit() {
    let html = ""

    if (this.videoLink.dataset.source == "file") {
      html = `<video class="text-video__player" controls autoplay><source src="${this.videoLink.dataset.file}" type="${this.videoLink.dataset.type}">Your browser does not support the video tag.</video>`
    } else if (this.videoLink.dataset.source == "youtube") {
      html = `<iframe class="text-video__iframe" src="https://www.youtube.com/embed/${this.videoLink.dataset.id}?autoplay=1" frameBorder="0" allow="autoplay" allowFullScreen></iframe>`
    } else if (this.videoLink.dataset.source == "vimeo") {
      html = `<iframe class="text-video__iframe" src="https://player.vimeo.com/video/${this.video.dataset.id}?autoplay=1" frameBorder="0" allow="autoplay" allowFullScreen></iframe>`
    }

    this.videoWrapper.innerHTML = html
  }

  videoModalInit() {
    document.addEventListener("keyup", this.modalKeypressHandler)

    //Create modal
    this.videoModal = document.createElement("div")
    this.videoModal.classList.add("text-video__modal")

    //Create close button
    const closeButton = document.createElement("button")
    closeButton.classList.add("text-video__modal-close")
    closeButton.innerHTML = '<i class="fa-solid fa-xmark"></i>'
    closeButton.addEventListener("click", (e) => this.closeVideoModal(e))
    this.videoModal.insertAdjacentElement("beforeend", closeButton)

    //Create video embed
    if (this.videoLink.dataset.source == "file") {
      const video = document.createElement("video")
      video.setAttribute("controls", "")
      video.setAttribute("autoplay", "")
      video.classList.add("text-video__modal-video")
      video.innerHTML = `<source src="${this.videoLink.dataset.file}" type="${this.videoLink.dataset.type}">`
      this.videoModal.insertAdjacentElement("beforeend", video)
    } else {
      let source
      if (this.videoLink.dataset.source == "youtube") {
        source = `https://www.youtube.com/embed/${this.videoLink.dataset.id}?&autoplay=1`
      }
      if (this.videoLink.dataset.source == "vimeo") {
        source = `https://player.vimeo.com/video/${this.videoLink.dataset.id}?autoplay=1`
      }

      const iframe = document.createElement("iframe")
      iframe.classList.add("text-video__modal-video")
      iframe.setAttribute("frameborder", "0")
      iframe.setAttribute("allow", "autoplay")
      iframe.setAttribute("allowfullscreen", "")
      iframe.setAttribute("src", source)
      this.videoModal.insertAdjacentElement("beforeend", iframe)
    }

    //Add modal to page
    document.body.insertAdjacentElement("beforeend", this.videoModal)
  }

  closeVideoModal() {
    this.videoModal.classList.add("text-video__modal--closing")

    setTimeout(() => {
      this.videoModal.remove()
      document.removeEventListener("keyup", this.modalKeypressHandler)
    }, 250)
  }

  modalKeypressHandler = (e) => {
    if (e.keyCode == 27) {
      this.closeVideoModal()
    }
  }
}

export default TextVideo
